// Servizi CMS (contenuti pagine pubbliche modificabili dall'admin).
import { api, unwrap } from './client';

export const cmsService = {
  /**
   * Documento CMS grezzo di una pagina: `{ section, data }`.
   * @param {string} slug
   */
  getPage: (slug) => unwrap(api.get(`/cms/page/${slug}`)),

  /**
   * SOLO il contenuto editoriale della pagina (`doc.data`), gia' normalizzato a `{}`.
   * E' il formato atteso dalla maggior parte dei consumer pubblici.
   * @param {string} slug
   * @returns {Promise<Object>}
   */
  getPageContent: async (slug) => {
    const doc = await unwrap(api.get(`/cms/page/${slug}`));
    return (doc && doc.data) || {};
  },

  /**
   * Salva il contenuto di una pagina (solo admin).
   * @param {string} slug
   * @param {Object} data
   */
  updatePage: (slug, data) => unwrap(api.put(`/cms/page/${slug}`, data)),
};
